import { render, staticRenderFns } from "./task_day.vue?vue&type=template&id=ed0dab40&scoped=true"
import script from "./task_day.vue?vue&type=script&lang=js"
export * from "./task_day.vue?vue&type=script&lang=js"
import style0 from "./task_day.vue?vue&type=style&index=0&id=ed0dab40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0dab40",
  null
  
)

export default component.exports